<div class="subtotal-info" *ngFor="let info of usersInfo">
  <div class="user-name">

    <div class="name-div">
      <div class="checkmark-icon" (click)="showHideUser(info)" style.color="#{{info.salesUser.bgColor}}"
           style.border-color="#{{info.salesUser.bgColor}}" [ngClass]="{'hide-mark': info.hideUser}"
           *ngIf="info.salesUser.id !== -99 || chartType === 'Chart'">
        <i class="pi pi-check"></i>
      </div>

      <div class="name-title" (click)="openUserWindow(info)">
        {{info.salesUser.name}}
        <mat-icon class="share-link">open_in_new</mat-icon>
      </div>
    </div>

    <div class="subtotal-line">
      <div class="subtotal-label">
        Estimates:
      </div>
      <div class="subtotal-num">
        {{info.totalAmt | currency}}
      </div>
    </div>
    <div class="subtotal-line">
      <div class="subtotal-label">
        Invoiced:
      </div>
      <div class="subtotal-num">
        {{info.invoicedBalance | currency}}
      </div>
    </div>
    <div class="subtotal-line">
      <div class="subtotal-label">
        Payments Recieved:
      </div>
      <div class="subtotal-num">
        {{info.paymentsReceived | currency}}
      </div>
    </div>
    <div class="subtotal-line">
      <div class="subtotal-label">
        Unbilled amount:
      </div>
      <div class="subtotal-num">
        {{info.unBilledAmount | currency}}
      </div>
    </div>
  </div>
